import React from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import TableRow from '../Table/TableRow/TableRow';
import SortIcon from '../../assets/icons/sort';
import { PROJECT_FILTER } from '../../interfaces/project';

type PropsType = {
  onFilter: (filter: PROJECT_FILTER) => void;
  selectedFilter?: string;
  filterStatus?: boolean;
};

const useStyles = makeStyles({
  root: {
    display: 'grid',
    gridTemplateColumns: '1.5fr 1fr 1fr 0.5fr',
    alignItems: 'center',
    height: '60px',
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
    cursor: 'pointer',
    alignItems: 'center',
  },
});

const ProjectTableHeader: React.FC<PropsType> = ({
  onFilter,
  selectedFilter,
  filterStatus = false,
}) => {
  const theme = useTheme();
  const classes = useStyles();

  return (
    <TableRow>
      <div className={classes.root}>
        <div className={classes.header} role="button" onClick={() => onFilter(PROJECT_FILTER.NAME)}>
          <Typography variant="body2">App icon & name</Typography>
          <SortIcon
            fill={
              selectedFilter === PROJECT_FILTER.NAME
                ? theme.palette.text.primary
                : theme.palette.grey[600]
            }
          />
        </div>

        <div className={classes.header} role="button" onClick={() => onFilter(PROJECT_FILTER.ID)}>
          <Typography variant="body2">App ID</Typography>
          <SortIcon
            fill={
              selectedFilter === PROJECT_FILTER.ID
                ? theme.palette.text.primary
                : theme.palette.grey[600]
            }
          />
        </div>

        <div
          className={classes.header}
          role="button"
          onClick={() => onFilter(PROJECT_FILTER.UPDATED)}
        >
          <Typography variant="body2">Last Updated</Typography>
          <SortIcon
            fill={
              selectedFilter === PROJECT_FILTER.UPDATED
                ? theme.palette.text.primary
                : theme.palette.grey[600]
            }
          />
        </div>

        <div
          className={classes.header}
          role="button"
          onClick={() => onFilter(PROJECT_FILTER.STATUS)}
        >
          <Typography variant="body2">Status</Typography>
          {filterStatus && (
            <SortIcon
              fill={
                selectedFilter === PROJECT_FILTER.STATUS
                  ? theme.palette.text.primary
                  : theme.palette.grey[600]
              }
            />
          )}
        </div>
      </div>
    </TableRow>
  );
};

export default ProjectTableHeader;
